import { PositionPointCriteria } from "./PositionPointCriteria"

export class FacePlatesSettings{
    PositionGaugingPointsOnFacePlates: boolean;
    PositionGaugingPointsOnBays: boolean;
    PositionPointCriteriaList: PositionPointCriteria[];
    PositionGaugingsforCriticalAreas: boolean
    CriticalAreaThreshold: number
}